import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledCardErrorDiv = styled.div`
  background-color: #ffebee;
  color: #d50000;
`

const CardError = ({children, ...otherProps}) => <StyledCardErrorDiv {...otherProps}>{children}</StyledCardErrorDiv>

CardError.propTypes = {
  children: PropTypes.any
}

export {CardError}
